var map = {
	"./icon1.png": "ca2d",
	"./icon2.png": "a4fe",
	"./icon3.png": "f982",
	"./icon4.png": "751a",
	"./icon5.png": "86fa",
	"./icon6.png": "b8a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e83d";